const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

export {$, $$};



// WEBPACK FOOTER //
// ./src/helpers.js